import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import Overlay from "../../SharedComponents/Overlay";
import { finishSession } from "../Store/Thunk";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ExitFullscreen } from "../../../Helpers/FullscreenHelper";
import ConfirmationModal from "../../SharedComponents/GeneralModals/Components/ConfirmationModal";

export default function AnsweringPageFooter(props) {
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);
  const sessionId = useSelector((state) => state.answeringApplication.sessionId);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLastEntryModalShown, setIsLastEntryModalShown] = useState(false);
  const { state } = useLocation();

  function timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  const FinishingFunction = () => {
    dispatch(finishSession({ id: sessionId }));
    navigate("/userDash");
    ExitFullscreen();
  };

  const FinishSession = () => {
    if (state.clickCounter === 4) {
      setIsLastEntryModalShown(true);
    } else {
      FinishingFunction();
    }
  };

  return (
    <>
      <ConfirmationModal
        isShown={isLastEntryModalShown}
        confirmationFunction={FinishingFunction}
        dismissFunction={() => {
          setIsLastEntryModalShown(false);
        }}
        setIsShown={setIsLastEntryModalShown}
        text={"Giriş hakkınız kalmadığı için bir daha devam edemezsiniz."}
        isCentered={true}
      ></ConfirmationModal>

      {isOverlayVisible && <Overlay text="Lütfen Bekleyiniz" />}

      <div
        style={{
          position: !props.isRelative ? "fixed" : "relative",
          bottom: "0",
          right: "0",
          width: "100%",
          height: window.innerWidth > 500 ? "80px" : "60px",
          borderTop: window.innerWidth > 500 && "1px solid #CECECE",
          background: window.innerWidth > 500 && "#FFF",
          borderRadius: props.isBorderRadius && "16px",
        }}
      >
        <Container>
          <Row className={"justify-content-center"} style={{ paddingTop: "16px" }}>
            {props.prevButtonFunction && (
              <>
                {!Boolean(props.hideSaveAndQuit) && (
                  <Col>
                    <Row></Row>
                  </Col>
                )}

                <Col xs={"auto"}>
                  <Row>
                    <Col xs={"auto"}>
                      <Button
                        disabled={props.isPrevDisabled}
                        onClick={() => props.prevButtonFunction(false)}
                        className="footer-prev-button"
                      >
                        {props.prevButtonText}
                      </Button>
                    </Col>
                    <Col xs={"auto"}>
                      <Button
                        variant="warning"
                        onClick={() => props.nextButtonFunction(false)}
                        className="footer-next-button"
                        disabled={props.isNextDisabled}
                      >
                        {props.nextButtonText}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </>
            )}
            {props.onClickFunction && (
              <>
                {!Boolean(props.hideSaveAndQuit) && (
                  <Col>
                    <Row></Row>
                  </Col>
                )}
                <Col xs={"auto"} onMouseDown={() => props.onMouseDownFunction && props.onMouseDownFunction(true)}>
                  <Button
                    className={"footer-next-button animate__animated   animate__fadeInUp  " + props.buttonClassName}
                    onClick={() => props.onClickFunction(props.data)}
                    disabled={props.isDisabled}
                    variant="warning"
                  >
                    {props.buttonText}
                  </Button>
                </Col>
              </>
            )}
            {!Boolean(props.hideSaveAndQuit) && ( // Ensures it's treated as `false` when undefined
              <Col>
                <Row className={"justify-content-end h-100"}>
                  <Col xs={"auto"}>
                    <Button
                      variant="warning"
                      className={"h-100"}
                      onClick={() => {
                        FinishSession();
                      }}
                    >
                      Kaydet ve Çık
                    </Button>
                  </Col>
                </Row>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </>
  );
}
